import React, {Component} from 'react';

class StrCom extends Component {

   render(){ 
    var street = require.context("../../../public/images/Photography/Street/", false, /.*\.jpg$/);
  return (
    
    <div class="phs1-item">
    <div class="phs1-container">
        <div class="phs1-item">
        {street.keys().map((imgs)=>
            <img src={process.env.PUBLIC_URL + "/images/Photography/Street/" + imgs.split("/").pop() } class="phs1-img"/>
        )}
        </div>
    </div>
    </div>
  );
}
}
export default StrCom;
